export default __webpack_public_path__ + "static/media/colour_-_on_light.779c67c5.svg";